import { useMemo } from 'react';
import { object, string } from 'yup';

export const getAllopathyValidationSchema = ({ t, type, name }) => useMemo(
	() =>
		object().shape({
			name: string().required(t('ALLOPATHY.VALIDATION.IS_REQUIRED', { value: name })),
			...(['advice', 'diet-exerise'].includes(type) ? { advice: string().required(t('ALLOPATHY.VALIDATION.ADVICE_REQUIRED')) } : {}),
			...(!['frequency'].includes(type) ? { status: string().required(t('ALLOPATHY.VALIDATION.STATUS_REQUIRED')) } : {}),
		}),
	[t, type, name],
);